/**
 * RepositoryView-new.tsx
 * New-page entry point for Repository View redesign.
 * This wrapper reuses the existing RepositoryView logic until Figma-specific UI is applied.
 */

import React from 'react';
import RepositoryViewPage from './RepositoryView';

/**
 * RepositoryViewNew
 * Named page component for the new Repository View route.
 */
function RepositoryViewNew(): React.ReactElement
{
    return <RepositoryViewPage />;
}

export default RepositoryViewNew;
